import React, { useState, useEffect } from "react";
import styles from "./PassportInfoMain.module.css";
import {useHistory} from 'react-router-dom'

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

function PassportInfoMain(props) {

  useEffect(()=>{
    if(props.passportDetails.application !== true){
      history.push('/dashboard/my-applications')
    }
    else if(props.passportDetails.passport_type !== undefined){
      setId(props.passportDetails.id);
      setFormId(props.passportDetails.document_id)
      setPassportType(props.passportDetails.passport_type)
      setGivenName(props.passportDetails.first_name," "+props.passportDetails.given_name)
      setSurName(props.passportDetails.last_name)
      setCountryOfBirth(props.passportDetails.country_of_birth)
      setDateOfBirthDate(props.passportDetails.date_of_birth_date)
      setDateOfBirthMonth(props.passportDetails.date_of_birth_month)
      setDateOfBirthYear(props.passportDetails.date_of_birth_year)
      setPassportIssuanceDate(props.passportDetails.passport_issuance_date_date)
      setPassportIssuanceMonth(props.passportDetails.passport_issuance_date_month)
      setPassportIssuanceYear(props.passportDetails.passport_issuance_date_year)
      setPassportExpiryDate(props.passportDetails.passport_expiry_date_date)
      setPassportExpiryMonth(props.passportDetails.passport_expiry_date_month)
      setPassportExpiryYear(props.passportDetails.passport_expiry_date_year)
      setNationality(props.passportDetails.nationality)
      setPassportIssuancePlace(props.passportDetails.passport_issuance_place)
      setSex(props.passportDetails.gender.toLowerCase())
      setPassportNumber(props.passportDetails.passport_number)
      setPlaceOfBirth(props.passportDetails.place_of_birth)
      
    }
    else{
      setId(props.passportDetails.id)

      if(props.details.givenName !== undefined && props.details.givenName !== null){
        setGivenName(props.details.givenName)
      }
      if(props.details.surName !== undefined && props.details.surName !== null){
        setSurName(props.details.surName)
      }
      if(props.details.passportType !== undefined && props.details.passportType !== null){
        setPassportType(props.details.passportType)
      }
      if(props.details.passportNumber !== undefined && props.details.passportNumber !== null){
        setPassportNumber(props.details.passportNumber)
      }
      if(props.details.sex !== undefined && props.details.sex !== null){
        setSex(props.details.sex)
      }
      if(props.details.nationality !== undefined && props.details.nationality !== null){
        setNationality(props.details.nationality)
      }
      if(props.details.dateOfBirthDate !== undefined && props.details.dateOfBirthDate !== null){
        setDateOfBirthDate(props.details.dateOfBirthDate)
      }
      if(props.details.dateOfBirthMonth !== undefined && props.details.dateOfBirthMonth !== null){
        setDateOfBirthMonth(props.details.dateOfBirthMonth)
      }
      if(props.details.dateOfBirthYear !== undefined && props.details.dateOfBirthYear !== null){
        setDateOfBirthYear(props.details.dateOfBirthYear)
      }
      if(props.details.passportExpiryDate !== undefined && props.details.passportExpiryDate !== null){
        setPassportExpiryDate(props.details.passportExpiryDate)
      }
      if(props.details.passportExpiryMonth !== undefined && props.details.passportExpiryMonth !== null){
        setPassportExpiryMonth(props.details.passportExpiryMonth)
      }
      if(props.details.passportExpiryYear !== undefined && props.details.passportExpiryYear !== null){
        setPassportExpiryYear(props.details.passportExpiryYear)
      }
      if(props.details.formId !== undefined && props.details.formId !== null){
        setFormId(props.details.formId)
      }
    }
  },[])


  const [passportType, setPassportType] = useState("");
  const [surName, setSurName] = useState("");
  const [givenName, setGivenName] = useState("");
  const [countryOfBirth, setCountryOfBirth] = useState("");

  const [dateOfBirthDate, setDateOfBirthDate] = useState("");
  const [dateOfBirthMonth, setDateOfBirthMonth] = useState("");
  const [dateOfBirthYear, setDateOfBirthYear] = useState("");

  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [passportNumber, setPassportNumber] = useState("");

  const [passportIssuanceDate, setPassportIssuanceDate] = useState("");
  const [passportIssuanceMonth, setPassportIssuanceMonth] = useState("");
  const [passportIssuanceYear, setPassportIssuanceYear] = useState("");

  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [passportExpiryMonth, setPassportExpiryMonth] = useState("");
  const [passportExpiryYear, setPassportExpiryYear] = useState("");

  const [nationality, setNationality] = useState("");
  const [passportIssuancePlace, setPassportIssuancePlace] = useState("");
  const [sex, setSex] = useState("");

  const [formId, setFormId] = useState("")

  const history = useHistory()
  const [id,setId] = useState("")

  const checkDateOfBirthDate = (e) => {
    if(e.length <= 2 && e < 32 && e !== "00"){
      setDateOfBirthDate(e)
    }
  }
  const checkDateOfBirthMonth = (e) => {
    if(e.length <= 2 && e < 13 && e !== "00"){
      setDateOfBirthMonth(e)
    }
  }  
  const checkDateOfBirthYear = (e) => {
    if(e.length <= 4 && e !== "0000"){
      setDateOfBirthYear(e)
    }
  }

  const checkPassportIssuanceDate = (e) => {
    if(e.length <= 2 && e < 32 && e !== "00"){
      setPassportIssuanceDate(e)
    }
  }
  const checkPassportIssuanceMonth = (e) => {
    if(e.length <= 2 && e < 13 && e !== "00"){
      setPassportIssuanceMonth(e)
    }
  }
  const checkPassportIssuanceYear = (e) => {
    if(e.length <= 4 && e !== "0000"){
      setPassportIssuanceYear(e)
    }
  }

  const checkPassportExpiryDate = (e) => {
    if(e.length <= 2 && e < 32 && e !== "00"){
      setPassportExpiryDate(e)
    }
  }
  const checkPassportExpiryMonth= (e) => {
    if(e.length <= 2 && e < 13 && e !== "00"){
      setPassportExpiryMonth(e)
    }
  }
  const checkPassportExpiryYear = (e) => {
    if(e.length <= 4 && e !== "0000"){
      setPassportExpiryYear(e)
    }
  }

  
  const nameValidation = /^[a-zA-Z]+ [a-zA-Z]+ [a-zA-Z]+$/;
  const nameValidation2 = /^[a-zA-Z]+ [a-zA-Z]+$/;
  const nameValidation3 = /^[a-zA-Z]+$/;
  const nameValidation4 = /^[a-zA-Z-]+$/;

  const goLater = () => {
    alert("save and later")
  }

  const go = () => {
    if(givenName === "" || surName === "" || passportType === "" || countryOfBirth === "" || passportNumber === "" || nationality === "" || sex === "" || passportIssuancePlace === "" || countryOfBirth === "" || passportExpiryDate === "" || passportExpiryMonth === "" || passportExpiryYear === "" || dateOfBirthDate === "" || dateOfBirthMonth === "" || dateOfBirthYear === "" || passportIssuanceDate === "" || passportIssuanceMonth === "" || passportIssuanceYear === "" ){
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          All Field Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    else if (
      nameValidation.test(givenName) === false &&
      nameValidation2.test(givenName) === false &&
      nameValidation3.test(givenName) === false
    ) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Please Enter Valid Given Name!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } 
    else if (
      nameValidation4.test(surName) === false
    ) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Sur Name Can Only Contains Latters &amp; -
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } 
    else if (dateOfBirthYear.length !== 4 || passportIssuanceYear.length !== 4 || passportExpiryYear.length !== 4){
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Years Must Be 4 Digits!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    else if(sex.toUpperCase() !== "MALE" && sex.toUpperCase() !== "FEMALE" && sex.toUpperCase() !== "OTHERS"){
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Gender Must Be "MALE", "FEMALE", "OTHERS"!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    else{
    const data = {
      ...props.passportDetails,
      document_id : formId,
      application: props.passportDetails.application,
      id: props.passportDetails.id,
      passport_type: passportType,
      first_name : ((givenName.split(" ")[1] === undefined)?(
       givenName.split(" ")[0]
      )
      :
      (
        (givenName.split(" ")[2] === undefined) ? (
        givenName.split(" ")[0]
        )
        :
        (
          (givenName.split(" ")[2] !== undefined) ? (
        givenName.split(" ")[0]

          )
          :
          ("")
        )
      )
     ),
      middle_name : ((givenName.split(" ")[1] === undefined)?(
        ""
       )
       :
       (
         (givenName.split(" ")[2] === undefined) ? (
          givenName.split(" ")[1]
         )
         :
         (
           (givenName.split(" ")[2] !== undefined) ? (
            givenName.split(" ")[1] +" "+ givenName.split(" ")[2]
           )
           :
           ("")
         )
       )
      ),
      last_name: surName,
      country_of_birth: countryOfBirth,
      place_of_birth: placeOfBirth,
      passport_number: passportNumber,
      nationality: nationality,
      passport_issuance_place: passportIssuancePlace,
      gender: sex.toUpperCase(),
      date_of_birth: (new Date(dateOfBirthYear, (dateOfBirthMonth - 1), dateOfBirthDate, 0, 0, 0, 0)).toISOString(),
      passport_issuance_date: (new Date(passportIssuanceYear, (passportIssuanceMonth - 1), passportIssuanceDate, 0, 0, 0, 0)).toISOString(),
      passport_expiry_date: (new Date(passportExpiryYear, (passportExpiryMonth - 1), passportExpiryDate, 0, 0, 0, 0)).toISOString(),
    
      date_of_birth_date: dateOfBirthDate,
      date_of_birth_month: dateOfBirthMonth,
      date_of_birth_year: dateOfBirthYear,

      passport_issuance_date_date: passportIssuanceDate,
      passport_issuance_date_month: passportIssuanceMonth,
      passport_issuance_date_year: passportIssuanceYear,

      passport_expiry_date_date: passportExpiryDate,
      passport_expiry_date_month: passportExpiryMonth,
      passport_expiry_date_year: passportExpiryYear,
    }
    props.ChangePassportDetails(data)
    history.push(`/dashboard/my-applications/${id}/other-info`)

  }
  }

  console.log(formId)


  return (
    <div>
      <h2 className={styles.head}>Application Form</h2>
      <div className={styles.mainBox}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>1</p>
          <p className={styles.FirstText}>Passport Information</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.inputsBox}>
          <div>
            <label for="passport-type" className={styles.label}>
              Passport Type
            </label>
            <br />
            <input
              type="text"
              id="passport-type"
              className={styles.input}
              value={passportType}
              onChange={(e) => setPassportType(e.target.value)}
            />
          </div>
          <div>
            <label for="Surname" className={styles.label}>
              Surname<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Surname"
              className={styles.input}
              value={surName}
              onChange={(e) => setSurName(e.target.value)}
            />
          </div>
          <div>
            <label for="Given-Name" className={styles.label}>
              Given Name<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Given-Name"
              className={styles.input}
              value={givenName}
              onChange={(e) => setGivenName(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Country-of-Birth" className={styles.label}>
              Country of Birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Country-of-Birth"
              className={styles.input}
              value={countryOfBirth}
              onChange={(e) => setCountryOfBirth(e.target.value)}
            />
          </div>
          <div>
            <label for="Date of Birth" className={styles.label}>
              Date of Birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span 
              className={styles.input2}
            >
              <input type="number"className={styles.inputIn} min="1" max="31" maxLength="2"  value={dateOfBirthDate} onChange={(e) => checkDateOfBirthDate(e.target.value)} />
              <input type="number"className={styles.inputIn}  min="1" max="12" maxLength="2"  value={dateOfBirthMonth} onChange={(e) => checkDateOfBirthMonth(e.target.value)} />
              <input type="number"className={styles.inputIn2} maxLength="2" value={dateOfBirthYear} onChange={(e) => checkDateOfBirthYear(e.target.value)} />
            </span>
          </div>
          <div>
            <label for="Place of birth" className={styles.label}>
              Place of birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Place of birth"
              className={styles.input}
              value={placeOfBirth}
              onChange={(e) => setPlaceOfBirth(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Passport Number" className={styles.label}>
              Passport Number<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Passport Number"
              type="text"
              className={styles.input}
              value={passportNumber}
              onChange={(e) => setPassportNumber(e.target.value)}
            />
          </div>
          <div>
            <label for="Passport Issuance Date" className={styles.label}>
              Passport Issuance Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span 
              className={styles.input2}
            >
              <input type="number"className={styles.inputIn} min="1" max="31" maxLength="2"  value={passportIssuanceDate} onChange={(e) => checkPassportIssuanceDate(e.target.value)} />
              <input type="number"className={styles.inputIn}  min="1" max="12" maxLength="2"  value={passportIssuanceMonth} onChange={(e) => checkPassportIssuanceMonth(e.target.value)} />
              <input type="number"className={styles.inputIn2} maxLength="2" value={passportIssuanceYear} onChange={(e) => checkPassportIssuanceYear(e.target.value)} />
            </span>
          </div>
          <div>
            <label for="Passport Expiry Date" className={styles.label}>
              Passport Expiry Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span 
              className={styles.input2}
            >
              <input type="number"className={styles.inputIn} min="1" max="31" maxLength="2"  value={passportExpiryDate} onChange={(e) => checkPassportExpiryDate(e.target.value)} />
              <input type="number"className={styles.inputIn}  min="1" max="12" maxLength="2"  value={passportExpiryMonth} onChange={(e) => checkPassportExpiryMonth(e.target.value)} />
              <input type="number"className={styles.inputIn2} maxLength="2" value={passportExpiryYear} onChange={(e) => checkPassportExpiryYear(e.target.value)} />
            </span>
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Nationality" className={styles.label}>
              Nationality<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Nationality"
              className={styles.input}
              value={nationality}
              onChange={(e) => setNationality(e.target.value)}
            />
          </div>
          <div>
            <label for="Passport Issuance Place" className={styles.label}>
              Passport Issuance Place<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Passport Issuance Place"
              className={styles.input}
              value={passportIssuancePlace}
              onChange={(e) => setPassportIssuancePlace(e.target.value)}
            />
          </div>
          <div>
            <label for="Sex" className={styles.label}>
              Sex<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Sex"
              className={styles.input}
              value={sex}
              onChange={(e) => setSex(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.btns}>
          {/* <button className={styles.btn1} onClick={()=>goLater()}>Save and continue later</button> */}
          <button className={styles.btn2} onClick={()=>go()}>Continue</button>
        </div>
      </div>


      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}


const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
  details: state.Details.details
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) => dispatch(changePassportDetails(passportDetails)),
});

export default connect(mapStateToProps, mapDispatchToProp)(PassportInfoMain);














    // if(givenName.split(" ")[1] === undefined){
    //   setFirstName(givenName.split(" ")[0])
    //   setMiddleName("")
    // }
    // else if(givenName.split(" ")[2] === undefined){
    //   setFirstName(givenName.split(" ")[0])
    //   setMiddleName(givenName.split(" ")[1])
    // } 
    // else if(givenName.split(" ")[2] !== undefined){
    //   setFirstName(givenName.split(" ")[0])
    //   setMiddleName(givenName.split(" ")[1] +" "+ givenName.split(" ")[2])
    // }